import * as React from 'react';
import * as lodash from 'lodash';
import { isValidArray } from 'src/Library/Helper';
import SEFieldLabel from './SEFieldLabel';
import SEFieldInput from './SEFieldInput';
import { DropdownMasterValues } from '../SEActions/SETasks/SETasks.interfaces';
import useFieldGroup from 'src/hooks/form/useFieldGroup';

const SESubFieldGroup = ({
  fieldGroup,
  dropdownMasterValues,
  onSubmit,
}: {
  fieldGroup: ReturnType<typeof useFieldGroup>;
  dropdownMasterValues: DropdownMasterValues;
  onSubmit?: () => void;
  }) => {
  return <div> hey </div>;
//   const asyncRerender = (cb: () => boolean) => {
//     setTimeout(() => {
//       if (cb()) {
//         fieldGroup.requestRerender();
//       } else {
//         asyncRerender(cb);
//       }
//     }, 100);
//   };

//   const getElemsWithShowLabel = ({
//     elems,
//     isParentObject,
//   }: {
//     elems: {
//       Node: any;
//       ref?: {
//         current?: {
//           field: {
//             refs?: {
//               current?: {
//                 field?: {
//                   extraData?: {
//                     fieldTemplateId: string;
//                   };
//                 };
//               };
//             }[];
//           };
//         };
//       };
//     }[];
//     isParentObject: boolean;
//   }) => {
//     const groupedElems = lodash.groupBy(elems, (elem) => {
//       const refs = elem?.ref?.current?.field?.refs;
//       return refs ? refs[0]?.current?.field?.extraData?.fieldTemplateId : undefined;
//     });
//     return Object.keys(groupedElems).reduce((acc, key) => {
//       acc = [
//         ...acc,
//         ...groupedElems[key]?.map((elem, idx) => {
//           const isLastElem = groupedElems[key]?.length - 1 === idx;
//           const field = elem?.ref?.current?.field as any;
//           const isFieldObject = field?.defaultRenderProps?.extraData?.type === 'OBJECT';
//           const isFieldSingle = field?.fieldType !== 'multi' && field?.fieldType !== 'group';
//           const showLabel = (isFieldSingle && !isParentObject) || (isFieldObject && idx === 0);

//           return {
//             ...elem,
//             showLabel,
//             labelBold: isFieldObject,
//             showDelete: !isLastElem,
//           };
//         }),
//       ];
//       return acc;
//     }, [] as any[]) as any[];
//   };

//   const renderFieldGroup = () => {
//     const isParentObject = fieldGroup?.extraData?.type === 'OBJECT';
//     return fieldGroup?.render(elems => {
//       const res: any[] = [];
//       const objectGroupLabels: any[] = [];

//       if (isValidArray(elems)) {
//         if (isParentObject) {
//           const groupLabels = elems.map((elem) => {
//             if (!elem) {
//               return;
//             }
//             const { ref } = elem;
//             const field = ref?.current?.field;
//             return (
//               <SEFieldLabel
//                 style={{ fontSize: 10, color: '#666666' }}
//                 label={field?.label}
//                 isRequired={field?.isRequired}
//                 onEdit={onSubmit && (() => {
//                   field?.enable();
//                   asyncRerender(() => !field?.disabled);
//                 })}
//               />
//             );
//           });
//           objectGroupLabels.push(...groupLabels);
//         }
          
//         const elemsWithShowLabel = getElemsWithShowLabel({
//           elems: elems as any[],
//           isParentObject,
//         });
//         elemsWithShowLabel.forEach((elem, idx) => {
//           if (!elem) return;
//           const { Node, ref, nodeKey } = elem;
//           const field = ref?.current?.field;
//           {
//             if (elem?.showLabel) {
//               res.push(
//                 <SEFieldLabel
//                   label={field?.label}
//                   isRequired={field?.isRequired}
//                   onEdit={onSubmit && (() => {
//                       field?.enable();
//                       asyncRerender(() => !field?.disabled);
//                     }
//                   )}
//                 />
//               );
//             }
//             if (field?.fieldType === 'group') {
//               // if(field?.extraData?.type === 'OBJECT') {
//               //   subGroups.push(field);
//               // }
//             } else {
//               res.push(
//                 <Node key={nodeKey}>
//                   {field?.fieldType === 'multi' ? (
//                     <></>
//                     // <SEMultiFieldGroup
//                     //   fieldGroup={fieldGroup}
//                     //   duplicateField={duplicateField}
//                     //   deleteField={deleteField}
//                     //   onSubmit={onSubmit}
//                     //   dropdownMasterValues={dropdownMasterValues}
//                     //   field={field}
//                     //   showLabel={elem?.showLabel}
//                     //   showDelete={elem?.showDelete}
//                     // />
//                   ) : (
//                     <SEFieldInput
//                       field={field}
//                       dropdownMasterValues={dropdownMasterValues}
//                       style={{ width: isParentObject ? '95%' : '90%' }}
//                     />
//                   )}
//                 </Node>
//               );
//             }
//           }
//         });
//       }

//       const renderObjectGroupLabels = () => {
//         return (
//           <>
//             <div
//               style={{
//                 display: 'grid',
//                 gridTemplateColumns: `repeat(${objectGroupLabels?.length}, 1fr)`,
//               }}
//             >
//               {objectGroupLabels}
//             </div>
//             <div
//               style={{
//                 display: 'grid',
//                 gridTemplateColumns: `repeat(${objectGroupLabels?.length}, 1fr)`,
//               }}
//             >
//               {res}
//             </div>
//           </>
//         );
//       };

//       return (
//         <>
//           {isParentObject && isValidArray(objectGroupLabels) ? (
//               <div>
//                 {renderObjectGroupLabels()}
//               </div>
//             ) : (
//               <div style={
//                 // !isMultiFieldPresent ?
//                 { display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 2fr' }
//                   // : undefined
//                   }>
//                 {res}
//               </div>
//             )}
//         </>
//       );
//     });
//   };

//   return <>{renderFieldGroup()}</>;

}

export default SESubFieldGroup;